export const hoverVideo = () => {

	//Play video only when cursor is hovering

	const hoverVideos = document.querySelectorAll("video.js__hover-video");
	if(hoverVideos.length > 0){

		hoverVideos.forEach((hoverVideo) => {

			var offHoverTimeout;

			//Load the video source in prep
			for (var source in hoverVideo.children) {
				var videoSource = hoverVideo.children[source];
				if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
					videoSource.src = videoSource.dataset.src;
				}
			}
			hoverVideo.load();

			//Add listener for mouse enter to start the video playing
			hoverVideo.addEventListener('mouseenter', (event) => {
				clearTimeout(offHoverTimeout);
				hoverVideo.play();
			});

			//Add listener for mosue leaving, to pause the video
			hoverVideo.addEventListener('mouseleave', (event) => {
				offHoverTimeout = setTimeout(() => {
					hoverVideo.pause();
					hoverVideo.currentTime = 0;
				},500);
				
			});
		
		});

	}


}